
import { supabase } from '@/integrations/supabase/client';
import { Slab } from '@/types/slab';
import { toast } from 'sonner';

export async function fetchSlabsFromSupabase(): Promise<Slab[]> {
  try {
    console.log('📊 Iniciando busca de slabs no Supabase...');
    
    // Primeiro vamos buscar os slabs
    const { data: slabs, error } = await supabase
      .from('cat_slabs')
      .select('*');

    if (error) {
      console.error('❌ Erro ao buscar slabs:', error);
      throw error;
    }

    if (!slabs) {
      console.log('⚠️ Nenhum slab encontrado');
      return [];
    }

    // Agora vamos buscar as locations separadamente para evitar problemas com o join
    const { data: locations } = await supabase
      .from('cat_locations')
      .select('id, name');

    // Criar um mapa de locations para lookup rápido
    const locationMap = new Map(
      locations?.map(loc => [loc.id, loc.name]) || []
    );

    return slabs.map(slab => ({
      id: slab.id,
      code: slab.code,
      name: slab.name,
      price: Number(slab.price),
      pricePerSqft: Number(slab.price_per_sqft),
      sqft: Number(slab.sqft),
      quantity: Number(slab.quantity),
      location: slab.location_id ? locationMap.get(slab.location_id) || '' : '',
      location_id: slab.location_id || '',
      price_group_id: slab.price_group_id || undefined,
      type: slab.type,
      imageUrl: slab.image_url || '/placeholder.svg',
      lastUpdated: new Date(slab.last_updated || Date.now()),
      dimensions: (slab.dimensions && 
        typeof slab.dimensions === 'object' && 
        'length' in slab.dimensions && 
        'height' in slab.dimensions) ? {
          length: Number(slab.dimensions.length || 0),
          height: Number(slab.dimensions.height || 0)
        } : null,
      barcode: slab.barcode || null,
      shareLink: slab.share_link || null,
      shareLinkExpiry: slab.share_link_expiry ? new Date(slab.share_link_expiry) : null,
    }));
  } catch (error) {
    console.error('❌ Erro ao buscar dados do Supabase:', error);
    toast.error('Falha ao carregar dados. Por favor, tente novamente mais tarde.');
    throw error;
  }
}
